import { segmentProperties, segmentsTracking } from 'src/common/lib/tracker';

// Define variables specific for the tracking this project, were moved to outsite of segmentTrackign to be available for export independing way
export const productTitle = 'Instana Price Estimator';
export const pageUrl = '/products/instana/pricing';

export const segmentTracking = (
  eventName: string,
  {
    pageTitle,
    object,
    resultValue,
    CTA,
    location,
    action,
    field,
  }: segmentProperties,
) => {
  //
  segmentsTracking(eventName, {
    productTitle,
    pageTitle,
    pageUrl,
    object,
    successFlag: true,
    resultValue,
    CTA,
    location,
    action,
    field,
  });
};
